{
    "criteria": [
        {
            "field": "PRIMARYSORTFIELD",
            "value": "TRADENAME",
            "valueArray": []
        },
        {
            "field": "PRIMARYSORTORDER",
            "value": "ASC",
            "valueArray": []
        },
        {
            "field": "SECONDARYSORTFIELD",
            "value": "None",
            "valueArray": []
        },
        {
            "field": "SECONDARYSORTORDER",
            "value": "ASC",
            "valueArray": []
        },
        {
            "field": "TERTIARYSORTFIELD",
            "value": "none",
            "valueArray": []
        },
        {
            "field": "TERTIARYSORTORDER",
            "value": "ASC",
            "valueArray": []
        }
    ]
}